import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mt-2 form-custom contact-access-section" }
const _hoisted_2 = { class: "apartment-parameters mb-1" }
const _hoisted_3 = {
  key: 0,
  class: "param-field"
}
const _hoisted_4 = {
  class: "p-field-label",
  for: "callingCode"
}
const _hoisted_5 = {
  for: "callingCode",
  class: "fs-13 label-error"
}
const _hoisted_6 = { class: "p-field" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { class: "fw-bold" }
const _hoisted_9 = { class: "bt-icon bt-icon--xs" }
const _hoisted_10 = { class: "ml-2" }
const _hoisted_11 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "bt-icon my-auto bt-icon--m" }, [
  /*#__PURE__*/_createVNode("span", { class: "bt-icon bt-icon--sm" }, [
    /*#__PURE__*/_createVNode("i", { class: "pi pi-user" })
  ])
], -1)
const _hoisted_13 = { class: "card__head d-flex flex-column w-100" }
const _hoisted_14 = { class: "ml-3 d-flex flex-column" }
const _hoisted_15 = { class: "bt-icon bt-icon--sm" }
const _hoisted_16 = { class: "btn-stripped d-flex align-items-center" }
const _hoisted_17 = { class: "btn-stripped d-flex align-items-center text-danger" }
const _hoisted_18 = {
  key: 0,
  class: "p-field"
}
const _hoisted_19 = { class: "fw-bold" }
const _hoisted_20 = { class: "apartment-parameters mt-3" }
const _hoisted_21 = {
  key: 0,
  class: "param-field"
}
const _hoisted_22 = {
  class: "p-field-label",
  for: "scsAddr"
}
const _hoisted_23 = {
  for: "scsAddr",
  class: "fs-13 label-error"
}
const _hoisted_24 = {
  key: 1,
  class: "param-field"
}
const _hoisted_25 = {
  class: "p-field-label",
  for: "buildingCode"
}
const _hoisted_26 = {
  key: 2,
  class: "param-field"
}
const _hoisted_27 = {
  class: "p-field-label",
  for: "riserCode"
}
const _hoisted_28 = {
  key: 3,
  class: "param-field"
}
const _hoisted_29 = {
  class: "p-field-label",
  for: "floorCode"
}
const _hoisted_30 = {
  key: 4,
  class: "param-field"
}
const _hoisted_31 = {
  class: "p-field-label",
  for: "apartmentCode"
}
const _hoisted_32 = { class: "p-field mt-2" }
const _hoisted_33 = { class: "d-flex align-items-center mb-3" }
const _hoisted_34 = { class: "fw-bold" }
const _hoisted_35 = { class: "bt-icon bt-icon--xs" }
const _hoisted_36 = { class: "ml-2" }
const _hoisted_37 = {
  key: 0,
  class: "text-gray"
}
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_40 = { class: "card__head d-flex flex-column w-100" }
const _hoisted_41 = { class: "ml-3 d-flex flex-column" }
const _hoisted_42 = { class: "text-dark" }
const _hoisted_43 = {
  key: 0,
  class: "fs-14"
}
const _hoisted_44 = {
  key: 1,
  class: "fs-14"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_Card = _resolveComponent("Card")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_DialogEditLabel = _resolveComponent("DialogEditLabel")
  const _component_DialogInviteResident = _resolveComponent("DialogInviteResident")
  const _component_DialogConfirmDelete = _resolveComponent("DialogConfirmDelete")
  const _component_DialogInfo = _resolveComponent("DialogInfo")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_ElScrollbar, { class: "details-panel-content-wrapper" }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_2, [
            (_ctx.isCallWithCode)
              ? (_openBlock(), _createBlock("div", _hoisted_3, [
                  _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("AppResourceEP.CallingCode")), 1),
                  _createVNode(_component_InputText, {
                    disabled: _ctx.disabled,
                    id: "callingCode",
                    class: ["w-100", { 'input-error': _ctx.codeNotValid }],
                    maxlength: "25",
                    modelValue: _ctx.editingApartment.code,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.editingApartment.code = $event))
                  }, null, 8, ["disabled", "modelValue", "class"]),
                  _createVNode("label", _hoisted_5, _toDisplayString(_ctx.invalidCodeReason), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("span", _hoisted_7, [
              _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("AppResourceEP.Labels")), 1),
              (!_ctx.isFloorsAddressing && !_ctx.isCallWithCode)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    disabled: _ctx.disabled,
                    class: "p-button-rounded p-button-outlined ml-auto",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkIfCanAddLabel()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode("span", _hoisted_9, [
                        _createVNode(_component_InlineSvgScoped, {
                          src: require(`@/assets/images/icons/icon-plus-outline.svg`),
                          "aria-label": "icon-plus"
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('AppResource.Add')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true)
            ]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedLabels, (label) => {
              return (_openBlock(), _createBlock(_component_Card, {
                class: "apartment-card m-3 card--slim",
                key: label.labelId
              }, {
                content: _withCtx(() => [
                  _createVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode("div", _hoisted_13, [
                      _createVNode("div", _hoisted_14, _toDisplayString(_ctx.getLabelText(label)), 1)
                    ]),
                    _createVNode(_component_ElDropdown, {
                      trigger: "click",
                      placement: "bottom-end",
                      "popper-class": "el-dropdown__popper el-dropdown--context"
                    }, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_ElDropdownMenu, { style: {"width":"300px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ElDropdownItem, {
                              disabled: _ctx.disabled,
                              onClick: ($event: any) => (_ctx.onEditLabelClick(label))
                            }, {
                              default: _withCtx(() => [
                                _createVNode("button", _hoisted_16, _toDisplayString(_ctx.$t("AppResource.Edit")), 1)
                              ]),
                              _: 2
                            }, 1032, ["disabled", "onClick"]),
                            (!_ctx.isFloorsAddressing && !_ctx.isCallWithCode)
                              ? (_openBlock(), _createBlock(_component_ElDropdownItem, {
                                  key: 0,
                                  disabled: _ctx.disabled,
                                  onClick: ($event: any) => (_ctx.onDeleteLabelClick(label.labelId ?? ''))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode("button", _hoisted_17, _toDisplayString(_ctx.$t("AppResource.Delete")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_Button, { class: "p-button-text p-1" }, {
                          default: _withCtx(() => [
                            _createVNode("span", _hoisted_15, [
                              _createVNode(_component_InlineSvgScoped, {
                                src: require(`@/assets/images/icons/icon-ellipsis-v.svg`),
                                "aria-label": "icon-ellipsis-v"
                              }, null, 8, ["src"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          (_ctx.isFloorsAddressing || !_ctx.adminView)
            ? (_openBlock(), _createBlock("div", _hoisted_18, [
                _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("AppResource.Parameters")), 1),
                _createVNode("div", _hoisted_20, [
                  (!_ctx.adminView)
                    ? (_openBlock(), _createBlock("div", _hoisted_21, [
                        _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("AppResourceEP.ApartmentNScsAddress")), 1),
                        _createVNode(_component_InputText, {
                          disabled: _ctx.disabled,
                          id: "scsAddr",
                          type: "number",
                          class: ["w-100", { 'input-error': _ctx.scsAddrNotValid }],
                          modelValue: _ctx.editingApartment.scsAddr,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.editingApartment.scsAddr = $event)),
                          min: _ctx.MIN_SCS_ADDRESS,
                          max: _ctx.MAX_SCS_ADDRESS
                        }, null, 8, ["disabled", "modelValue", "min", "max", "class"]),
                        _createVNode("label", _hoisted_23, _toDisplayString(_ctx.invalidScsReason), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isFloorsAddressing)
                    ? (_openBlock(), _createBlock("div", _hoisted_24, [
                        _createVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("AppResourceEP.Building")), 1),
                        _createVNode(_component_InputText, {
                          disabled: "",
                          id: "buildingCode",
                          class: "w-100",
                          modelValue: _ctx.editingApartment.buildingCode,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.editingApartment.buildingCode = $event))
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isFloorsAddressing)
                    ? (_openBlock(), _createBlock("div", _hoisted_26, [
                        _createVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("AppResourceEP.Riser")), 1),
                        _createVNode(_component_InputText, {
                          disabled: "",
                          id: "riserCode",
                          class: "w-100",
                          modelValue: _ctx.editingApartment.riserCode,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.editingApartment.riserCode = $event))
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isFloorsAddressing)
                    ? (_openBlock(), _createBlock("div", _hoisted_28, [
                        _createVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("AppResourceEP.Floor")), 1),
                        _createVNode(_component_InputText, {
                          disabled: "",
                          id: "floorCode",
                          class: "w-100",
                          modelValue: _ctx.editingApartment.floorCode,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.editingApartment.floorCode = $event))
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isFloorsAddressing)
                    ? (_openBlock(), _createBlock("div", _hoisted_30, [
                        _createVNode("label", _hoisted_31, _toDisplayString(_ctx.$t("AppResourceEP.Apartment")), 1),
                        _createVNode(_component_InputText, {
                          disabled: "",
                          id: "apartmentCode",
                          class: "w-100",
                          modelValue: _ctx.editingApartment.apartmentCode,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.editingApartment.apartmentCode = $event))
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_32, [
            _createVNode("div", _hoisted_33, [
              _createVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('AppResource.Invitations')), 1),
              _createVNode(_component_Button, {
                disabled: _ctx.disableInvite,
                class: ["p-button-rounded p-button-outlined ml-auto", { disabled: !_ctx.currentEntrancePlant.syncStatus?.isPlantActive }],
                onClick: _ctx.toggleInviteDialog
              }, {
                default: _withCtx(() => [
                  _createVNode("span", _hoisted_35, [
                    _createVNode(_component_InlineSvgScoped, {
                      src: require(`@/assets/images/icons/icon-plus-outline.svg`),
                      "aria-label": "icon-plus"
                    }, null, 8, ["src"])
                  ]),
                  _createVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('AppResource.Invite')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "class", "onClick"])
            ]),
            (_openBlock(), _createBlock("div", {
              key: _ctx.currentInvitations.length
            }, [
              (_ctx.currentInvitations.length === 0)
                ? (_openBlock(), _createBlock("small", _hoisted_37, _toDisplayString(_ctx.$t('entrancePlant.noUserInvitedYet')), 1))
                : (_openBlock(), _createBlock("div", _hoisted_38, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentInvitations, (cInvitation) => {
                      return (_openBlock(), _createBlock(_component_Card, {
                        class: "apartment-card m-3 card--slim",
                        key: cInvitation.email
                      }, {
                        content: _withCtx(() => [
                          _createVNode("div", _hoisted_39, [
                            _createVNode("div", {
                              class: ["avatar", cInvitation.status == 0 ? 'avatar__disabled' : 'avatar__enabled']
                            }, _toDisplayString(_ctx.userInitials(cInvitation)), 3),
                            _createVNode("div", _hoisted_40, [
                              _createVNode("div", _hoisted_41, [
                                _createVNode("div", {
                                  class: "d-flex flex-column",
                                  style: { opacity: cInvitation.status == 0 ? '.5' : '1' }
                                }, [
                                  _createVNode("span", _hoisted_42, _toDisplayString(cInvitation.email ?? ""), 1),
                                  (cInvitation.status == 0)
                                    ? (_openBlock(), _createBlock("span", _hoisted_43, _toDisplayString(_ctx.$t('AppResource.InvitePending')), 1))
                                    : _createCommentVNode("", true),
                                  (cInvitation.status == 1)
                                    ? (_openBlock(), _createBlock("span", _hoisted_44, _toDisplayString(_ctx.$t('AppResource.InviteAccepted')), 1))
                                    : _createCommentVNode("", true)
                                ], 4)
                              ])
                            ]),
                            _createVNode(_component_Button, {
                              class: "text-danger ml-auto p-button-text",
                              onClick: ($event: any) => (_ctx.openDeleteInviteConfirm(cInvitation))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Remove")), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]))
            ]))
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_DialogEditLabel, {
      isVisible: _ctx.isVisibleDialogEditLabel,
      labelToEdit: _ctx.labelToEdit,
      isEdit: _ctx.isEdit,
      addressingType: _ctx.currentEntrancePlant.addressingType,
      onHideDialog: _ctx.hideLabelDialog,
      onSaveLabel: _ctx.onSaveLabel
    }, null, 8, ["isVisible", "labelToEdit", "isEdit", "addressingType", "onHideDialog", "onSaveLabel"]),
    _createVNode(_component_DialogInviteResident, {
      isVisible: _ctx.isVisibleDialogInviteResident,
      apartment: _ctx.editingApartment,
      onUpdateList: _ctx.handleUpdateList,
      onHideDialog: _ctx.toggleInviteDialog
    }, null, 8, ["isVisible", "apartment", "onUpdateList", "onHideDialog"]),
    _createVNode(_component_DialogConfirmDelete, {
      "is-visible": _ctx.isVisibleDeleteInviteConfirm,
      title: _ctx.$t('AppResourceEP.RemoveInvitedUser'),
      message: _ctx.revokeInviteMessage,
      onHideDialog: _ctx.closeDeleteInviteConfirm,
      onConfirm: _ctx.handleDeleteInvite
    }, null, 8, ["is-visible", "title", "message", "onHideDialog", "onConfirm"]),
    _createVNode(_component_DialogInfo, {
      isVisible: _ctx.isVisibleMaxEntity,
      title: _ctx.$t('AppResource.Warning'),
      message: _ctx.$t('AppResourceEP.PopupMessageMaxLabelsReachedWarning'),
      onHideDialog: _ctx.toggleMaxEntityDialog
    }, null, 8, ["isVisible", "title", "message", "onHideDialog"])
  ], 64))
}